export default "<h1>Zahlungen</h1>\r\n"